import { render, staticRenderFns } from "./reportPostDetail.vue?vue&type=template&id=7a2cfb58"
import script from "./reportPostDetail.vue?vue&type=script&lang=js"
export * from "./reportPostDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports